import React, { useEffect, useState } from "react";
import type { BaseSelectRef } from "rc-select/lib/BaseSelect";
// Redux
import { useDispatch, useSelector } from "react-redux";

import { setToast } from "../../../../redux/actions/toast";

// Ajax Methods
import ajaxMethods from "../../../../api/ajax-methods";

// Ajax End Points
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { appInsights } from "../../../../config/appInsights";
import { RootState } from "../../../../redux/store";
import { MixPanel } from "../../../../shared/MixPanel/MixPanel";
import useGetRejectionReasons from "../../../../custom-hooks/useGetRejectionReasons";
import ButtonLoader from "../../../../UI/Loaders/Loaders";
import { Select } from "antd";
import { useRef } from "react";

interface IState {
  comment: string;
  rejectReason: number | null;
}

const Deny = (props: any) => {
  const [state, setState] = useState<IState>({
    comment: "",
    rejectReason: null,
  });
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [selectedItems, setSelectedItems] = useState<number[]>([]);

  const selectReasonRef = useRef<BaseSelectRef>(null);

  const {
    dataRecord: { loan_id },
  } = props;

  const {
    disbursements: { records },
  } = useSelector((state: RootState) => state?.loansReducer);

  const { data: rejectionReasons, isLoading: isLoadingRejectionReasons } =
    useGetRejectionReasons();
  const filteredOptions = rejectionReasons?.filter(
    (o: any) => !selectedItems.includes(o),
  );

  console.log({ selectedItems });

  useEffect(() => {
    MixPanel.track(`Page View: DenyLoan.tsx`, {
      page: "DenyLoan.tsx",
    });
  }, []);

  const handleSelect = (value: any, option: any) => {
    if (option.value === "0") {
      selectReasonRef?.current?.blur();
    }
  };

  const handleChange = (values: string[]) => {
    const numericValues = values.map((value) => Number(value));
    setSelectedItems(numericValues);
  };

  const onCommentChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setState((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  // Deny Single Loan
  const denyLoan = (e: any) => {
    e.preventDefault();
    setIsLoading(true);
    let payload: {
      id: number;
      declineReasons: number[];
      customDeclineReason?: string;
    };
    const { comment } = state;

    payload = {
      id: Number(loan_id),
      declineReasons: selectedItems.filter((item) => item !== 0) as number[],
    };

    if (state.comment) {
      payload.customDeclineReason = comment;
    }

    ajaxMethods
      .post(ajaxEndpoints.DENY_LOANS, payload)
      .then((response) => {
        if (response) {
          if (response.data.status === true) {
            // this.props.removeDeniedLoans(loans);
            MixPanel.track("Get Loan", {
              distinct_id: `${props?.dataRecord?.borrower_details?.email}`,
              "customer id": `${props?.dataRecord?.borrower_details?.borrower_id}`,
              "loan amount": `${props?.dataRecord?.loan_amount_requested}`,
              "loan tenor": `${props?.dataRecord?.loan_tenure}`,
              "product name": `${props?.dataRecord?.product_detail?.product_name}`,
              "loan status": `Loan Declined`,
            });
            dispatch(setToast("success", response.data.message));

            props.onCloseModal();
          } else {
            dispatch(setToast("warning", "Could not deny selected loans"));

            props.onCloseModal();
          }
        } else {
          dispatch(setToast("warning", "Could not deny selected loans"));
          props.onCloseModal();
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "Deny.tsx",
          },
        });
        dispatch(setToast("warning", error));
        props.onCloseModal();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const {
    borrower_details: { first_name, last_name },
    loan_amount,
  } = records.find((record: any) => {
    return parseInt(record.loan_id) === parseInt(loan_id);
  });

  return (
    <div className="LoanModal Modal__content">
      <div className="Modal__body" style={{ overflow: "hidden" }}>
        {/* <h3 className="Modal__title p-b-1">Loan ID: <span>{loan_id}</span></h3> */}
        <h3 className="Modal__title p-b-1">Rejection Summary</h3>
        {/* 2. Confirm Update Role Modal*/}
        <div id="update-role-confirm">
          <div className="m-b-30">
            <h5>Are you sure you want to reject the following loan? </h5>
            <form onSubmit={denyLoan} className="form-horizontal mt-40">
              <label style={{ width: "100%" }}>
                Borrower Name
                <input
                  className="form-control"
                  value={`${first_name} ${last_name}`}
                  readOnly
                />
              </label>
              <label style={{ width: "100%" }}>
                Loan Amount
                <input className="form-control" value={loan_amount} readOnly />
              </label>
              <label style={{ width: "100%" }}>
                Reason for Rejection
                <Select
                  ref={selectReasonRef}
                  mode="multiple"
                  placeholder={
                    isLoadingRejectionReasons
                      ? "Loading please wait..."
                      : "Select reason(s)"
                  }
                  value={selectedItems.map((item) => String(item))}
                  onSelect={handleSelect}
                  onChange={handleChange}
                  style={{ width: "100%", height: "50px" }}
                  options={filteredOptions?.map((item: any) => ({
                    value: String(item.id),
                    label: item.name,
                  }))}
                  disabled={isLoadingRejectionReasons}
                  getPopupContainer={(trigger) => trigger.parentElement}
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      <div
                        style={{
                          padding: "8px",
                          borderTop: "1px solid #f0f0f0",
                          textAlign: "right",
                        }}
                      >
                        <button
                          type="button"
                          className="btn btn-sm advancly-btn"
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={() => selectReasonRef.current?.blur()}
                        >
                          Done
                        </button>
                      </div>
                    </>
                  )}
                />
              </label>
              {selectedItems.includes(0) && (
                <label style={{ width: "100%" }}>
                  Comment
                  <textarea
                    className="form-control"
                    name="comment"
                    value={state?.comment}
                    onChange={onCommentChange}
                    placeholder="Reason for rejection"
                  />
                </label>
              )}
              <div className="Form__action-buttons m-t-2">
                <button
                  type="submit"
                  data-mode="disburse"
                  data-id={loan_id}
                  onClick={denyLoan}
                  disabled={!state?.comment && selectedItems.length === 0}
                  className="btn zoom-element reject_btn_2 m-0 mr-auto"
                >
                  {isLoading ? (
                    <ButtonLoader />
                  ) : (
                    <span>
                      {" "}
                      <i className="fa fa-check-circle" /> Reject Loan
                    </span>
                  )}
                </button>
                <button
                  type="button"
                  onClick={props.onCloseModal}
                  className="btn zoom-element reject_btn m-0 ml-auto"
                >
                  <i className="fa fa-times-circle" /> Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
        {/* 3. Updating Role Loader*/}
        <div
          id="update-role"
          style={{ display: "none" }}
          className=" loading-overlay speed-1x fadeInRight"
        >
          <div className=" form-loader form-loader-login verify">
            <div className="centerLoader">
              <div className="loading" id="adv-loader-alt" />
              <div className="center-txt webapp-ripple-text">
                <i className="notifier fas fa-user-cog" />
                Denying Loan Request ...
              </div>
            </div>
          </div>
        </div>

        {/* 4. Update Role Success Message*/}
        <div
          id="update-role-success"
          style={{ display: "none" }}
          className="loading-overlay speed-1x fadeInRight"
        >
          <div className="form-loader form-loader-login verify">
            <div className="centerLoader">
              <div className="loading success-loader">
                <i className="webapp-ripple-notification success-text fa fa-check-circle" />
              </div>
              <div className="center-txt webapp-ripple-text">
                <i className="notifier far fa-check-circle" />
                Loan Request Denied
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Deny;
